// TODO: why this inside matomo?
export enum BetTypes {
    SINGLE = 'single',
    SUBSCRIPTION = 'subs',
    COMBINATION = 'combo',
    MULTI = 'multi',
}
